import { render, staticRenderFns } from "./RecommendHouse.vue?vue&type=template&id=31d18e88&scoped=true&"
import script from "./RecommendHouse.vue?vue&type=script&lang=js&"
export * from "./RecommendHouse.vue?vue&type=script&lang=js&"
import style0 from "./RecommendHouse.vue?vue&type=style&index=0&id=31d18e88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d18e88",
  null
  
)

export default component.exports